import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {UnLitElement} from "../../../common/elements";
import {resolve} from "../../../container";
import {Dialogs} from "./dialogs";
import {handleActivationKey} from "../../../common/utils/events";

@customElement("eop-inline-dialog-link")
export class EopInlineDialogLink extends UnLitElement {

    @property({attribute: "dialog-id"})
    public dialogId: string;
    @property({attribute: "style"})
    public linkStyle: string;
    @property()
    public label: string;

    public constructor(private dialogs: Dialogs = resolve(Dialogs)) {
        super();
    }

    public render(): TemplateResult {
        return html`
            <button type="button" @click=${this.openDialog} @keydown=${this.openDialogOnKeydown}>
                <span class="layer-link link ${this.linkStyle}">${this.label}</span>
            </button>
        `;
    }

    private openDialog(): void {
        void this.dialogs.open(this.dialogId);
    }

    private openDialogOnKeydown(e: KeyboardEvent): void {
        handleActivationKey(e, () => this.openDialog());
    }
}